import { Typography, Box } from "@mui/material";

export default function Header({
  dadosDetalhesConsulta,
  EhNeurologista = false,
  ...props
}) {
  return (
    <Box id="Header" className="container">
      <Typography className="title">
        Detalhes da consulta {EhNeurologista && "neurológica "}ID{" "}
        {dadosDetalhesConsulta.consulta.id}
      </Typography>
      <Typography className="text">
        <span className="textStrong">Paciente: </span>
        {dadosDetalhesConsulta.paciente.nome}
      </Typography>
      <Typography className="text">
        <span className="textStrong">Profissional responsável: </span>
        {dadosDetalhesConsulta.responsavel.nome}
      </Typography>
      <Typography className="text">
        <span className="textStrong">CRM/UF: </span>
        {dadosDetalhesConsulta.responsavel.crm}/
        {dadosDetalhesConsulta.responsavel.crmUF}
      </Typography>
      <Typography className="textSpan">
        Realizado em formato{" "}
        <span className="textStrong">
          {dadosDetalhesConsulta.consulta.formato.toLowerCase()}
        </span>{" "}
        em:{" "}
        <span className="textStrong">
          {dadosDetalhesConsulta.consulta.dataConsulta}
        </span>
      </Typography>
    </Box>
  );
}
